<glxy-form-field class="opportunity-info__input" appearance="outline">
  <glxy-label>{{ 'FRONTEND.SALES_UI.COMMON.ASSIGNEE' | translate }}</glxy-label>
  <mat-select [value]="assigneeId$ | async" (selectionChange)="updateAssignee($event.value)">
    <mat-option *ngFor="let sp of salespeople$ | async" [value]="sp.id">
      {{ sp.fullName | translate }}
    </mat-option>
  </mat-select>
</glxy-form-field>
